const speciesImage = {
  "Human": "human",
  "Wookie": "wookie",
  "Hutt": "hutt",
  "Rodian": "rodian",
  "Droid": "droid",
  "Yoda's species": "yoda",
  "Trandoshan": "trandoshan",
  "Mon Calamari": "moncalamari",
  "Ewok": "ewok",
  "Sullustan": "sullustan",
  "Neimodian": "neimodian",
  "Gungan": "gungan",
  "Toydarian": "toydarian",
  "Dug": "dug",
  "Cerean": "cerean",
  "Kaminoan": "kaminoan"
};

export default speciesImage;